
export function getWording(filePath){  
    var fileLink = '';
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        fileLink = filePath+"?t="+new Date().getTime()
    } else {
        fileLink = window.info.config.filepathname +filePath+"?t="+new Date().getTime()
    }
    return window.fetch(fileLink)
    .then((response) => response.json())
    .then((wordingJson) => {
        return wordingJson;
    })
    .catch((error) => {
        console.error(error);
    });
}